import { useRouter } from 'next/compat/router';
import usePaths from 'hooks/use-paths';

export const useConciergeNavigate = (): (() => void) => {
  const router = useRouter();
  const { href } = usePaths();

  return () => {
    void router?.push(`${href}/concierge`);
  };
};
